import { gql } from '@apollo/client';
import { PartnerTaxExemptionInfo } from '../fragments';

export default gql`
  query PartnerTaxExemptions($partnerOrganizationId: ID, $state: String) {
    partnerTaxExemptions(
      partnerOrganizationId: $partnerOrganizationId
      state: $state
    ) {
      ...PartnerTaxExemptionInfo
    }
  }
  ${PartnerTaxExemptionInfo}
`;
